import { styled } from "../../theme/Theme";

export const Image = styled("img")((theme) => ({}));
